export const ENVIRONMENT = {
	PROD: "PROD",
	STAGE: "STAGE",
	DEV: "DEV",
	PRE_PROD: "PRE_PROD",
};

export const PAGESTATES = {
	LOADING: "LOADING",
	OPEN: "OPEN",
	CLOSE: "CLOSE",
	ERROR: "ERROR",
};

export const APISTATES = {
	HIT: "HIT",
	SUCCESS: "SUCCESS",
	FAILURE: "FAILURE",
};

export const PAGENAMES = {
	SELF_KYC: "SELF_KYC",
};

export const SPACE = "&amp";

export const SECTIONSTATES = {
	HIDDEN: "HIDDEN",
	CLOSE: "CLOSE",
	OPEN: "OPEN",
};

export const FIELDTYPES = {
	TEXT: "text",
	LINKLIST: "linklist",
	NUMBER: "number",
	PASSWORD: "password",
	BUTTON: "button",
	SEARCH: "search",
	SELECTIONRAIL: "selectionRail",
	SUBMIT: "submit",
	BADGE: "badge",
	RADIO: "radio",
	STEPPER: "stepper",
	CHECKBOX: "checkbox",
	DIVIDER: "divider",
	DROPDOWN: "dropdown",
	APPEND: "append",
	OTP: "otp",
	CALLOUT: "callout",
	VIDEO: "video",
	PHOTO: "photo",
	LENGTHTEXT: "lengthtext",
	DROPDOWNSEARCH: "dropdownsearch",
	INFO: 'info',
	PADDING: 'padding',
	FILEUPLOAD: 'file-upload'
};

export const SOURCEINFOTYPES = {
	LINKLIST: "linklist",
	OPTIONS: "OPTIONS",
	STATIC: "STATIC",
};

export const ACTIONCTAERRORINFO = {
	RETRY: "retry",
	RELOAD: "reload",
	DONE: "done",
	HOME: "home",
	ERROR: "error",
	MODAL: "modal",
	COMMONERRORMSG:
		"Your request failed due to some technical error, try again after sometime.",
	GOTOHOMECTA: "GO TO HOME",
	DONECTA: "DONE",
	LOCATION: "location",
	AUTORETRY: "autoretry",
	OK: "OK"
};

export const COMMONUSERBLOCKERRORINFO = {
	type: true,
	state: ACTIONCTAERRORINFO.MODAL,
	text: ACTIONCTAERRORINFO.COMMONERRORMSG,
	actionCta: {
		text: ACTIONCTAERRORINFO.GOTOHOMECTA,
		action: ACTIONCTAERRORINFO.HOME,
	},
};

export const SECTIONTYPES = {
	FORM: "FORM",
	PROGRESS: "PROGRESS",
	INFO: "INFO",
	SUBMIT: "SUBMIT",
	ACKNOWLEDGEMENT: "ACKNOWLEDGEMENT",
	STATIC_RAIL: "STATIC_RAIL",
	MODAL: "MODAL",
	INFO_RAIL: "INFO_RAIL",
	ERRORMODAL: "ERRORMODAL",
};

export const LAYOUTS = {
	NO_CARD: "NO_CARD",
	MODAL: "MODAL",
	MODAL_WITH_CLOSE: "MODAL_WITH_CLOSE",
	MARGIN_TOP: "MARGIN_TOP",
	STATUS_VIEW: "STATUS_VIEW",
	ERRORMODAL: "ERRORMODAL",
	LOCATION_MODAL: "LOCATION_MODAL",
	HIDDEN: "HIDDEN",
	FAILURE: "FAILURE",
	FETCH_LOCATION: "FETCH_LOCATION",
	TOOLTIP: "TOOLTIP",
	SUBTITLEASTITLE: "SUBTITLEASTITLE",
	INFO: "INFO"
};

export const SECTIONID = {
	KycPersonalDetails: "KycPersonalDetails",
};

export const ACTIONSMAPPINGTYPES = {
	API: "API",
	API_REDIRECTION: "API_REDIRECTION",
	COLLAPSE_NEXT: "COLLAPSE_NEXT",
	ATTRIBUTE_HANDLER: "ATTRIBUTE_HANDLER",
	FILTER_HANDLER: "FILTER_HANDLER",
	MODAL: "MODAL",
	ATTRIBUTE_HANDLER_MODAL: "ATTRIBUTE_HANDLER_MODAL",
	CLONE: "CLONE",
	API_COLLAPSE_NEXT: "API_COLLAPSE_NEXT",
	REDIRECTION: "REDIRECTION",
	CUSTOM_REDIRECTION_SKYC: "CUSTOM_REDIRECTION_SKYC",
	CLOSE_MODAL: "CLOSE_MODAL",
	ERRORMODAL: "ERRORMODAL",
};

export const STEPPER_STATUS_MAP = {
	IN_PROGRESS: "default",
	NOT_STARTED: "disabled",
	COMPLETED: "success",
};

export const fieldActionConstants = {
	UPDATE_VALUE: "UPDATE_VALUE",
	UPDATE_OPTIONS: "UPDATE_OPTIONS",
	UPDATE_ALL: "UPDATE_ALL",
	UPDATE_ATTRIBUTES: "UPDATE_ATTRIBUTES",
	UPDATE_DEPENDENT_FIELDS: "UDPATE_DEPENDENT_FIELDS",
	ENABLE_FILTER: "ENABLE_FILTER",
	UPDATE_CHECKED: "UPDATE_CHECKED",
	UPDATE_ERRORINFO: "UPDATE_ERRORINFO",
	UPDATE_APPENDED: "UPDATE_APPENDED",
	RESET_VALUES: "RESET_VALUES",
};

export const STATES = {
	NONE: "none",
	WARNING: "warning",
	LOADING: "loading",
	FAILED: "failed",
	ERROR: "error",
	MODAL: "modal",
};

export const ACTIONLABELPOS = {
	ROW: "row",
	CTA: "cta",
	TOOLTIP: "tooltip",
	TITLETEXT: "titleText",
};

export const DEPKEYS = {
	STATUS: "status",
	VALUE: "value",
};

export const BUTTON_TYPES = {
	PRIMARY: "primary",
	SECONDARY: "secondary",
};

export const BUTTON_VERSIONS = {
	FIXED_PADDING: "fixed-padding",
};

export const LEAD_DATA_STORAGE_MODULE_NAME = "fetched";
export const LEAD_DATA_STORAGE_KEY_NAME = "LeadData";
export const ACQUISTITION_DATA_STORAGE_MODULE_NAME = "acquisition";
export const ACQUISTITION_DATA_STORAGE_KEY_NAME = "leaddata";
export const SKYC_MODULE_NAME = "skyc";
export const SKYC_KEY_NAME = "valuemap";
export const SECTION_DEPENDENCY = "sectiondependency";
export const SECURITYALERTCOCP = "Security Alert. You Are Opening Multiple Window. This window will now close.";
export const SESSIONERROR = "Session Ended. This window will now close.";
export const cocpInstance = "cocpInstance";
export const cocpHome = "COCP_VerifyMobileNumber";
export const cameraPermissionNetworkIssue = "Poor network connection detected. Please check your connectivity";
export const GoToHomeBtn = "GO TO HOME";
export const FIXED_BUTTON_ONCLICK_TYPE = {
	CUSTOM_REDIRECTION_SKYC: "CUSTOM_REDIRECTION_SKYC",
};

export const formDataHeaders = {
	"content-type": "multipart/form-data",
	appName: "ecaf",
};

export const SUCCESS_CODE = "200";

export const SECTION_STATES_VALUES = {
	PENDING: "pending",
	COMPLETED: "completed",
};

export const SECTION_LAYOUT_VALUES = {
	RESET: "RESET",
};

export const FETCHING_LOCATION_TEXT = "Fetching Location.....";

export const NORESULT = "No Result Found";

export const LOB = "$.localStorage.acquisitionleaddata.lob";

export const JOURNEYNAME = "$.localStorage.acquisitionleaddata.journeyName";

export const LEADID = "$.localStorage.acquisitionleaddata.leadId";
export const CUSTOM_LEADID = "$.localStorage.fetchedLeadData.id";

export const INGRESS = "$.localStorage.acquisitionleaddata.ppn";

export const COCP = "COCP_END_USER_SKYC";

export const AnalyticsConstants = {
	PLAN_SELECTION: "pack_selection",
	PLAN_TITLE_DETAILS: "plan_tile_details",
	PLAN_TITLE: "plan_tile",
	PLAN_MORE_DETS: "plan_more_dets",
};

export const TOOLTIPCONSTANTS = {
	KycPersonalDetails: "Note: Details fetched via ID proof can not be edited.",
};

export const FACE_AUTH_UIDAI = "uncropped_user.vs.user_uidai";

export const userIdentifierTypeA = "A";
export const userIdentifierTypeV = "V"